import { OneClassLogo } from './OneClassLogo';
export default OneClassLogo;
